// Traduction des libellés natifs React (chrome de l'appli : toolbar table/arbre, messages de
// validation, boutons de popup...) — distinct des libellés métier (label/items des champs JSON),
// déjà traduits en amont par l'application cible à la génération du JSON (hors périmètre ici).
// Codes de langue alignés sur ceux du JSON toolbar (`__TBS_TOOLBAR__.buttons[].languages`, voir
// CLAUDE.md) : codes ISO 639-1 minuscules — "fr" (langue de repli, DEFAULT_LANG), "en", "es", "de",
// "it", "ar". Arabe : traduction textuelle seulement, pas de mise en page RTL (`dir="rtl"`) — hors
// périmètre.
import { createContext, useContext } from 'react'

export const DEFAULT_LANG = 'fr'

const DICT = {
  fr: {
    loading:        'Chargement…',
    requiredField:  'Champ obligatoire',
    invalidFormat:  'Format invalide',
    searchMinChars: 'Saisir au moins 3 caractères…',
    noResult:       'Aucun résultat',
    noValue:        'Aucune valeur',
    noData:         'Aucune donnée',
    groupBy:        'Grouper par',
    resetGrouping:  'Réinitialiser',
    columns:        'Colonnes ▾',
    reloadTable:    'Rafraîchir le tableau',
    filter:         'Filtrer…',
    filterHint:     'a, b, …',
    selectedCount:  '{n} sélect.',
    page:           'Page {page} / {total}',
    rows:           '{n} ligne(s)',
    reduceMenu:     'Réduire le menu',
    openMenu:       'Ouvrir le menu',
    home:           'Accueil',
    ok:             'OK',
    cancel:         'Annuler',
    close:          'Fermer',
    hide:           'Masquer',
    pleaseWait:         'Veuillez patienter…',
    selectionRequired:  'Sélection obligatoire',
    invalidDateFormat:  'Format invalide (jj/mm/aaaa)',
    invalidTimeFormat:  'Format invalide (HH:MM)',
    invalidNumberFormat: 'Format invalide (numérique)',
    chatButtonLabel: 'Assistant',
    chatTitle:       'Assistant',
    chatHide:        "Masquer l'assistant",
    chatMaximize:    'Agrandir',
    chatRestore:     'Restaurer',
    chatCopy:        'Copier',
    chatSpeak:       'Lire à voix haute',
    chatStopSpeak:   'Arrêter la lecture',
    chatThumbsUp:    'Bonne réponse',
    chatThumbsDown:  'Mauvaise réponse',
    chatPlaceholder: 'Écrivez votre message…',
    chatSend:        'Envoyer',
    chatAttach:      'Joindre un fichier',
    chatVoice:       'Dicter le message',
    chatVoiceError:  'Dictée indisponible ({error})',
  },
  en: {
    loading:        'Loading…',
    requiredField:  'Required field',
    invalidFormat:  'Invalid format',
    searchMinChars: 'Type at least 3 characters…',
    noResult:       'No results',
    noValue:        'No value',
    noData:         'No data',
    groupBy:        'Group by',
    resetGrouping:  'Reset',
    columns:        'Columns ▾',
    reloadTable:    'Refresh table',
    filter:         'Filter…',
    filterHint:     'a, b, …',
    selectedCount:  '{n} selected',
    page:           'Page {page} / {total}',
    rows:           '{n} row(s)',
    reduceMenu:     'Collapse menu',
    openMenu:       'Expand menu',
    home:           'Home',
    ok:             'OK',
    cancel:         'Cancel',
    close:          'Close',
    hide:           'Hide',
    pleaseWait:         'Please wait…',
    selectionRequired:  'Selection required',
    invalidDateFormat:  'Invalid format (dd/mm/yyyy)',
    invalidTimeFormat:  'Invalid format (HH:MM)',
    invalidNumberFormat: 'Invalid format (numeric)',
    chatButtonLabel: 'Assistant',
    chatTitle:       'Assistant',
    chatHide:        'Hide assistant',
    chatMaximize:    'Maximize',
    chatRestore:     'Restore',
    chatCopy:        'Copy',
    chatSpeak:       'Read aloud',
    chatStopSpeak:   'Stop reading',
    chatThumbsUp:    'Good response',
    chatThumbsDown:  'Bad response',
    chatPlaceholder: 'Type your message…',
    chatSend:        'Send',
    chatAttach:      'Attach a file',
    chatVoice:       'Dictate message',
    chatVoiceError:  'Voice input unavailable ({error})',
  },
  es: {
    loading:        'Cargando…',
    requiredField:  'Campo obligatorio',
    invalidFormat:  'Formato inválido',
    searchMinChars: 'Escriba al menos 3 caracteres…',
    noResult:       'Sin resultados',
    noValue:        'Sin valor',
    noData:         'Sin datos',
    groupBy:        'Agrupar por',
    resetGrouping:  'Restablecer',
    columns:        'Columnas ▾',
    reloadTable:    'Actualizar tabla',
    filter:         'Filtrar…',
    filterHint:     'a, b, …',
    selectedCount:  '{n} seleccionado(s)',
    page:           'Página {page} / {total}',
    rows:           '{n} fila(s)',
    reduceMenu:     'Reducir menú',
    openMenu:       'Abrir menú',
    home:           'Inicio',
    ok:             'OK',
    cancel:         'Cancelar',
    close:          'Cerrar',
    hide:           'Ocultar',
    pleaseWait:         'Espere por favor…',
    selectionRequired:  'Selección obligatoria',
    invalidDateFormat:  'Formato inválido (dd/mm/aaaa)',
    invalidTimeFormat:  'Formato inválido (HH:MM)',
    invalidNumberFormat: 'Formato inválido (numérico)',
    chatButtonLabel: 'Asistente',
    chatTitle:       'Asistente',
    chatHide:        'Ocultar asistente',
    chatMaximize:    'Maximizar',
    chatRestore:     'Restaurar',
    chatCopy:        'Copiar',
    chatSpeak:       'Leer en voz alta',
    chatStopSpeak:   'Detener lectura',
    chatThumbsUp:    'Buena respuesta',
    chatThumbsDown:  'Mala respuesta',
    chatPlaceholder: 'Escriba su mensaje…',
    chatSend:        'Enviar',
    chatAttach:      'Adjuntar archivo',
    chatVoice:       'Dictar mensaje',
    chatVoiceError:  'Dictado no disponible ({error})',
  },
  de: {
    loading:        'Wird geladen…',
    requiredField:  'Pflichtfeld',
    invalidFormat:  'Ungültiges Format',
    searchMinChars: 'Mindestens 3 Zeichen eingeben…',
    noResult:       'Keine Ergebnisse',
    noValue:        'Kein Wert',
    noData:         'Keine Daten',
    groupBy:        'Gruppieren nach',
    resetGrouping:  'Zurücksetzen',
    columns:        'Spalten ▾',
    reloadTable:    'Tabelle aktualisieren',
    filter:         'Filtern…',
    filterHint:     'a, b, …',
    selectedCount:  '{n} ausgewählt',
    page:           'Seite {page} / {total}',
    rows:           '{n} Zeile(n)',
    reduceMenu:     'Menü einklappen',
    openMenu:       'Menü öffnen',
    home:           'Startseite',
    ok:             'OK',
    cancel:         'Abbrechen',
    close:          'Schließen',
    hide:           'Ausblenden',
    pleaseWait:         'Bitte warten…',
    selectionRequired:  'Auswahl erforderlich',
    invalidDateFormat:  'Ungültiges Format (TT.MM.JJJJ)',
    invalidTimeFormat:  'Ungültiges Format (HH:MM)',
    invalidNumberFormat: 'Ungültiges Format (numerisch)',
    chatButtonLabel: 'Assistent',
    chatTitle:       'Assistent',
    chatHide:        'Assistent ausblenden',
    chatMaximize:    'Maximieren',
    chatRestore:     'Wiederherstellen',
    chatCopy:        'Kopieren',
    chatSpeak:       'Vorlesen',
    chatStopSpeak:   'Vorlesen stoppen',
    chatThumbsUp:    'Gute Antwort',
    chatThumbsDown:  'Schlechte Antwort',
    chatPlaceholder: 'Nachricht eingeben…',
    chatSend:        'Senden',
    chatAttach:      'Datei anhängen',
    chatVoice:       'Nachricht diktieren',
    chatVoiceError:  'Diktat nicht verfügbar ({error})',
  },
  it: {
    loading:        'Caricamento…',
    requiredField:  'Campo obbligatorio',
    invalidFormat:  'Formato non valido',
    searchMinChars: 'Digitare almeno 3 caratteri…',
    noResult:       'Nessun risultato',
    noValue:        'Nessun valore',
    noData:         'Nessun dato',
    groupBy:        'Raggruppa per',
    resetGrouping:  'Ripristina',
    columns:        'Colonne ▾',
    reloadTable:    'Aggiorna tabella',
    filter:         'Filtra…',
    filterHint:     'a, b, …',
    selectedCount:  '{n} selezionato/i',
    page:           'Pagina {page} / {total}',
    rows:           '{n} riga/righe',
    reduceMenu:     'Riduci menu',
    openMenu:       'Apri menu',
    home:           'Home',
    ok:             'OK',
    cancel:         'Annulla',
    close:          'Chiudi',
    hide:           'Nascondi',
    pleaseWait:         'Attendere prego…',
    selectionRequired:  'Selezione obbligatoria',
    invalidDateFormat:  'Formato non valido (gg/mm/aaaa)',
    invalidTimeFormat:  'Formato non valido (HH:MM)',
    invalidNumberFormat: 'Formato non valido (numerico)',
    chatButtonLabel: 'Assistente',
    chatTitle:       'Assistente',
    chatHide:        "Nascondi l'assistente",
    chatMaximize:    'Ingrandisci',
    chatRestore:     'Ripristina',
    chatCopy:        'Copia',
    chatSpeak:       'Leggi ad alta voce',
    chatStopSpeak:   'Interrompi lettura',
    chatThumbsUp:    'Buona risposta',
    chatThumbsDown:  'Cattiva risposta',
    chatPlaceholder: 'Scrivi il tuo messaggio…',
    chatSend:        'Invia',
    chatAttach:      'Allega un file',
    chatVoice:       'Detta messaggio',
    chatVoiceError:  'Dettatura non disponibile ({error})',
  },
  ar: {
    loading:        'جارٍ التحميل…',
    requiredField:  'حقل إلزامي',
    invalidFormat:  'تنسيق غير صالح',
    searchMinChars: 'أدخل 3 أحرف على الأقل…',
    noResult:       'لا توجد نتائج',
    noValue:        'لا توجد قيمة',
    noData:         'لا توجد بيانات',
    groupBy:        'تجميع حسب',
    resetGrouping:  'إعادة ضبط',
    columns:        'الأعمدة ▾',
    reloadTable:    'تحديث الجدول',
    filter:         'تصفية…',
    filterHint:     'a, b, …',
    selectedCount:  '{n} محدد',
    page:           'صفحة {page} / {total}',
    rows:           '{n} صف(وف)',
    reduceMenu:     'طي القائمة',
    openMenu:       'فتح القائمة',
    home:           'الرئيسية',
    ok:             'موافق',
    cancel:         'إلغاء',
    close:          'إغلاق',
    hide:           'إخفاء',
    pleaseWait:         'الرجاء الانتظار…',
    selectionRequired:  'الاختيار إلزامي',
    invalidDateFormat:  'تنسيق غير صالح (يوم/شهر/سنة)',
    invalidTimeFormat:  'تنسيق غير صالح (HH:MM)',
    invalidNumberFormat: 'تنسيق غير صالح (رقمي)',
    chatButtonLabel: 'المساعد',
    chatTitle:       'المساعد',
    chatHide:        'إخفاء المساعد',
    chatMaximize:    'تكبير',
    chatRestore:     'استعادة',
    chatCopy:        'نسخ',
    chatSpeak:       'قراءة بصوت عالٍ',
    chatStopSpeak:   'إيقاف القراءة',
    chatThumbsUp:    'إجابة جيدة',
    chatThumbsDown:  'إجابة سيئة',
    chatPlaceholder: 'اكتب رسالتك…',
    chatSend:        'إرسال',
    chatAttach:      'إرفاق ملف',
    chatVoice:       'إملاء الرسالة',
    chatVoiceError:  'الإملاء غير متاح ({error})',
  },
}

// Fonction pure (pas de hook) — utilisable aussi bien pendant le rendu (via useT() ci-dessous) que
// dans du code impératif hors rendu (ex. UserMessages.jsx, API impérative tbsUserMessages, qui lit
// la langue courante via une ref plutôt qu'un hook). `vars` : interpolation `{clé}` simple, sans
// dépendance externe (pluriels/formats avancés hors périmètre de ce prototype).
export function translate(lang, key, vars) {
  const str = DICT[lang]?.[key] ?? DICT[DEFAULT_LANG][key] ?? key
  if (!vars) return str
  return str.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? '')
}

const LangContext = createContext(DEFAULT_LANG)
export const LangProvider = LangContext.Provider

// eslint-disable-next-line react-refresh/only-export-components
export function useLang() {
  return useContext(LangContext)
}

// eslint-disable-next-line react-refresh/only-export-components
export function useT() {
  const lang = useContext(LangContext)
  return (key, vars) => translate(lang, key, vars)
}
